module.exports = __webpack_public_path__ + "static/media/crypto.a269de32.png";